import type { ComponentPropsWithoutRef, HTMLAttributes } from "react";
import type Link from "next/link";

import type { TIconKey } from "@/ui/components/primitives/Icon";

/*-------------------------------------
|  Constants
|-------------------------------------*/

// screen height, minus header height (h-11), minus container padding (py-6)
export const DESKTOP_HEIGHT_CLASS = "xl:h-[calc(90vh-7rem)]";

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TResponsiveNavigationItem = {
  href: string;
  icon: TIconKey;
  label: string;
  value: string;
  linkProps?: Omit<
    ComponentPropsWithoutRef<typeof Link>,
    "children" | "href"
  >;
};

export type TResponsiveNavigationProps = Omit<
  HTMLAttributes<HTMLElement>,
  "children" | "onChange"
> & {
  activeValue?: string;
  items: readonly TResponsiveNavigationItem[];
  ariaLabel?: string;
};

export type TResponsiveNavigationItemProps = {
  isActive: boolean;
  item: TResponsiveNavigationItem;
};

/*-------------------------------------
|  Defaults
|-------------------------------------*/
